// extracted by mini-css-extract-plugin
export default {"tabs":"InfoPage_tabs__RD-BP","tab":"InfoPage_tab__tOnoZ"};